<template>
  <table-render ref="tableRender" :config="config" />
</template>

<script>
import tableRender from '@/components/tableRender';
import { subAccountLog as config } from './config';
export default {
  props: {
    subAccountNumberId: {
      type: [String, Number],
      require: true
    }
  },
  name: 'SubAccountLog',
  data() {
    return {
      config
    };
  },
  components: { tableRender },
  watch: {},
  computed: {},
  methods: {},
  created() {
    this.config[0].childMenu[0].defaultQuery.subAccountNumberId = this.subAccountNumberId;
  },
  mounted() {},
  beforeDestroy() {}
};
</script>

<style scoped lang="scss"></style>
